import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { vanessa } from "../characters/Vanessa";
import { images } from "./images";
import { ann } from '../characters/Ann';
import { mc } from '../characters/MC';
import Question from '../../src/shell/Questions';
import { V6UnderPassAfter } from './V6';
import Game from '../../src/shell/Game';
import { empty } from '../characters/empty';
import { officer } from '../characters/Officer';
import { joe } from "../characters/Joe";

export const V6Underpass_Car = async (): Promise<any> => {
    ImageClass.setImage(images.v6.Underpass_0, { transition: true, duration: 0.6 });
    vanessa.talk(`That was close.`);
    ImageClass.setImage(images.v6.Underpass_1);
    joe.talk(`I still don't understand why you don't let me meet your parents... It's been a while now.`);
    vanessa.talk(`Don't worry, honey. I will.`);
    joe.talk(`Ok, so what now?`);
    vanessa.talk(`I know a place we can go to.`);
    joe.talk(`Where is it?`);
    vanessa.talk(`I'll navigate you, just start driving.`);
    joe.talk(`Alright.`);
    ImageClass.setImage(images.v6.Underpass_4);
    ann.talk(`I just hope we won't stay there too late... Wherever this place may be.`);
    vanessa.talk(`Why? You ain't got work or anything.`);
    ann.talk(`I have plans.`);
    vanessa.talk(`Spill it! Since when you've been hiding secrets from me?`);
    ann.talk(`I'll tell you tomorrow, I don't want to jinx it.`);

    mc.think(`She must mean the audition... I wonder why she doesn't want to tell Vanessa about that.`);

    vanessa.talk(`Whatever.`);
    ImageClass.setImage(images.v6.Underpass_2);
    vanessa.talk(`There it is. Just go under the bridge.`);
    joe.talk(`Seriously?`);
    vanessa.talk(`Keep driving!`);
    joe.talk(`You are the boss...`);
    ImageClass.setImage(images.v6.Underpass_3, { transition: true });
    joe.talk(`Are you sure we are in the right place?`);
    vanessa.talk(`Yup!`);
    vanessa.talk(`I used to come here all the time.`);
    vanessa.talk(`Park the car but don't turn the engine off so we'll have some lights.`);

    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_LikesJoey_StayingHere`)) {

        return jump(V6Underpass_Car_Ann, "V6Underpass_Car_Ann");
    } else {

        return jump(V6Underpass_Car_Vanessa, "V6Underpass_Car_Vanessa");
    }
};

export const V6Underpass_Car_Ann = async (): Promise<any> => {
    ImageClass.setImage(images.v6.Underpass_4);
    ann.talk(`Go ahead I wanna ask ${mc.name} something.`);
    vanessa.talk(`Now?`);
    ann.talk(`Yes.`);
    ann.talk(`Whatever.`);
    ImageClass.setImage(images.v6.Underpass_5, { transition: true, duration: 0.6 });
    ann.talk(`I just wanted to say thanks for not leaving me alone. Hehe.`);
    mc.talk(`Of course!`);
    ann.talk(`I took that pill so I'm kinda dizzy...`);
    mc.talk(`Yeah, I knew that's one of the reasons why I stayed.`);
    ann.talk(`Hehe, thanks again.`);
    ann.talk(`Well, that's it.\nLet's join them.`);

    return jump(V6Underpass, "V6Underpass");
};

export const V6Underpass_Car_Vanessa = async (): Promise<any> => {
    ImageClass.setImage(images.v6.Underpass_4);
    vanessa.talk(`Go ahead, ${mc.name} and I will be right behind you.`);
    ann.talk(`Why?`);
    vanessa.talk(`You are not the only one keeping secrets.`);
    ann.talk(`...`);

    ImageClass.setImage(images.v6.Underpass_7, { transition: true, duration: 0.6 });
    vanessa.talk(`You know, I didn't have time to say it, but I appreciate it.`);
    mc.talk(`Appreciate what?`);
    vanessa.talk(`That you are keeping quiet.`);
    mc.talk(`I'd be fucked too if I say anything.`);
    vanessa.talk(`I just gave you a compliment, just shut up and accept it.`);
    mc.talk(`Haha, sure.`);
    vanessa.talk(`Anyway, that's not the main reason I kept you here.`);
    vanessa.talk(`I'm gonna test Ann.`);
    mc.talk(`Test her? In what way?`);
    vanessa.talk(`You'll see.`);
    mc.talk(`And...? Are you asking for my permission?`);
    vanessa.talk(`No. I'm just letting you know.`);
    mc.think(`I guess that's a progress when it comes to Vanessa...`);
    mc.talk(`Thanks? I guess?`);
    vanessa.talk(`Anytime!`);
    mc.talk(`Are you sure about that? You just gave her that pill of yours...`);
    vanessa.talk(`That's the best time to do it!`);
    vanessa.talk(`Let's join them.`);

    return jump(V6Underpass, "V6Underpass");
};


export const V6Underpass = async (): Promise<any> => {
    ImageClass.setImage(images.v6.Underpass_9, { transition: true });
    vanessa.talk(`So? Isn't this place cool?`);
    ann.talk(`Hehe, not really...`);
    ann.talk(`And how do you know this place anyway?`);
    vanessa.talk(`I already said, I used to come here with friends.`);
    ann.talk(`And do what?`);
    vanessa.talk(`Not asking so many questions.`);
    ann.talk(`...`);
    ann.talk(`What the fuck? You just asked me tons of questions at your place.`);
    vanessa.talk(`So?`);
    ann.talk(`...`);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_LikesJoey_StayingHere`)) {
        vanessa.talk(`Did I tell you that I love your new outfit?`);
        ann.talk(`A couple of times, hehe.`);
        vanessa.talk(`Yeah. It's really hot.`);
        ann.talk(`${mc.name} likes it as well.`);
        vanessa.talk(`I'm sure he does.`);
    } else {

        vanessa.talk(`What did you do in the room with Joe?`);
        ann.talk(`Why don't you ask Joe? He is right here.`);
        joe.talk(`I like to listen when I'm in a group.`);
        ann.talk(`Hehe, yeah I can see that.`);
        vanessa.talk(`So?`);
        ann.talk(`We were just talking.`);
        vanessa.talk(`About what?`);
        ann.talk(`I don't know, a bit of everything.`);

        vanessa.talk(`Did he compliment you on your outfit? I bet he did.`);
        joe.talk(`I said it looks nice.`);
        vanessa.talk(`I knew it.`);
        vanessa.talk(`It does look nice.`);
        vanessa.talk(`Did I tell you it looks nice?`);
        ann.talk(`Hehe, you have.`);
    }

    return jump(V6Underpass_2, "V6Underpass_2");
};

export const V6Underpass_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.Underpass_9, { transition: true });

    vanessa.talk(`It kinda reminds me of someone.`);
    ann.talk(`Who?`);
    vanessa.talk(`A hot chick that I see every day... When I look at the mirror.`);
    ImageClass.setImage(images.v6.Underpass_10);
    vanessa.talk(`Are you trying to be like me?`);
    ImageClass.setImage(images.v6.Underpass_11);
    ann.talk(`Hehe, no! But I could if I wanted to do.`);
    vanessa.talk(`Haha, no way.`);

    ImageClass.setImage(images.v6.Underpass_9);
    vanessa.talk(`Cute shy Ann wouldn't be able to last one day in my shoes.`);
    ann.talk(`What size are you?`);
    vanessa.talk(`...`);
    vanessa.talk(`Anyway... Clothes are one thing.`);
    vanessa.talk(`But can you really take it to the next level?`);
    ann.talk(`What do you mean?`);
    ImageClass.setImage(images.v6.Underpass_12);
    mc.think(`Holy shit, is she really gonna do that right now?`);
    ann.talk(`What are you doing?`);
    vanessa.talk(`Something you wouldn't.`);
    ImageClass.setImage(images.v6.Underpass_13);
    vanessa.talk(`Have you ever been topless in public?`);
    ann.talk(`Hehe, no...`);
    vanessa.talk(`That's what I thought.`);
    ImageClass.setImage(images.v6.Underpass_14);
    ann.talk(`Oh! Do you think I won't?`);
    vanessa.talk(`No way!`);
    vanessa.talk(`Do it!`);
    ImageClass.setImage(images.v6.Underpass_15);
    ann.talk(`Done!`);
    joe.talk(`Nice!`);
    mc.think(`I believe that's the first time Joe, or another man besides me has seen Ann's boobs.`);
    ImageClass.setImage(images.v6.Underpass_16);
    vanessa.talk(`So? How does it feel?`);
    ann.talk(`Kinda good, hehe.`);
    vanessa.talk(`You surprised me, and that's not easy.`);

    ann.talk(`I told you earlier! I've changed!`);
    vanessa.talk(`I can see that! Too bad it took you so long... The things we could've done together.`);
    ann.talk(`Like what?`);
    vanessa.talk(`We'll talk about it some other time... In private. Haha.`);

    vanessa.talk(`Anyway, it's nice that you are starting to get loose, but there is one problem.`);
    ann.talk(`What?`);
    ImageClass.setImage(images.v6.Underpass_17);
    vanessa.talk(`I like to be the center of attention, and you are kinda stealing it away from me.`);
    mc.think(`Yeah... Everyone could've guessed that.`);
    vanessa.talk(`And, do you know what's more interesting than a topless girl?`);
    ImageClass.setImage(images.v6.Underpass_18);
    vanessa.talk(`A nude one.`);
    mc.think(`She was not wrong... I couldn't take my eyes off her.`);
    mc.think(`Neither did Joey. He hadn't stop smiling since we got here.`);
    ImageClass.setImage(images.v6.Underpass_19);
    ann.talk(`Is that a challenge?`);
    vanessa.talk(`To be honest, it's not. The challenge stopped once you took off your top.`);
    ann.talk(`I've gone this far, so why stop now?`);


    ImageClass.setImage(images.v6.Underpass_20);
    vanessa.talk(`You wouldn't!`);
    ImageClass.setImage(images.v6.Underpass_21);
    ann.talk(`Done!`);
    mc.think(`She really did it!`);
    mc.think(`Oh... She shaved her pubes.`);
    vanessa.talk(`Ann.`);
    ann.talk(`Yes?`);
    vanessa.talk(`I'm impressed.`);
    ImageClass.setImage(images.v6.Underpass_22);

    vanessa.talk(`I feel like I found a new best friend.`);
    ann.talk(`Wouldn't you miss the old Ann?`);
    vanessa.talk(`Fuck old Ann!`);
    ann.talk(`Hehe, yeah, fuck her.`);

    return jump(V6Underpass_3, "V6Underpass_3");
};

export const V6Underpass_3 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.Underpass_22);
    vanessa.talk(`But you know... It makes me curious.`);
    ann.talk(`Curious?`);
    vanessa.talk(`Yeah...`);
    ImageClass.setImage(images.v6.Underpass_23);
    vanessa.talk(`I won't lie. Taking off your clothes in public is a big step.`);
    mc.think(`What is she planning right now?`);
    ImageClass.setImage(images.v6.Underpass_25);
    vanessa.talk(`It makes me wonder...`);
    ImageClass.setImage(images.v6.Underpass_26);
    vanessa.talk(`How far you'd go?`);
    ImageClass.setImage(images.v6.Underpass_24);
    mc.think(`It looks like Ann is copying Vanessa.`);
    vanessa.talk(`I see you are up to it.`);
    ImageClass.setImage(images.v6.Underpass_26);
    ann.talk(`I told you! Old Ann is no more.`);
    ImageClass.setImage(images.v6.Underpass_30);
    mc.think(`Oh! Ann has just raised the bar.`);
    ImageClass.setImage(images.v6.Underpass_26);
    vanessa.talk(`I see how it is.`);
    ImageClass.setImage(images.v6.Underpass_27);
    vanessa.talk(`Honey.`);
    joe.talk(`Yes, babe?`);
    vanessa.talk(`Help me out here.`);
    joe.talk(`You know I'm always down.`);
    vanessa.talk(`Do it.`);
    ImageClass.setImage(images.v6.Underpass_28, { duration: 1 });
    mc.think(`Joey took off his clothes... Why did they talk like they did it before? He never told me about that.`);
    vanessa.talk(`You are quiet. Getting nervous?`);
    ann.talk(`No!`);
    ImageClass.setImage(images.v6.Underpass_29);
    vanessa.talk(`And if I do this?`);
    ImageClass.setImage(images.v6.Underpass_31);
    ann.talk(`No way I'm letting her get away with this.`);
    mc.talk(`What do you have in mind?`);
    return jump(V6Underpass_3_Question, "V6Underpass_3_Question");
};

export const V6Underpass_3_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.Underpass_31);
    await ann.setQuestion(new Question({ text: `Take off your clothes.`, options: { think: false }, key: `v6UnderPassTakeYourClothesOff` })
        .option({ title: `Do it`, key: true })
        .option({ title: `Refuse`, key: false }));


    if (Question.globalAnswers.v6UnderPassTakeYourClothesOff) {
        return jump(V6Underpass_3_Question_Doit, "V6Underpass_3_Question_Doit");
    } else {
        return jump(V6Underpass_3_Question_Refuse, "V6Underpass_3_Question_Refuse");
    }
};


export const V6Underpass_3_Question_Doit = async (): Promise<any> => {
    ImageClass.setImage(images.v6.Underpass_31);
    mc.talk(`Sure.`);
    ImageClass.setImage(images.v6.Underpass_32, { transition: true, duration: 0.6 });
    mc.think(`Damn. She is holding my cock so tightly, I don't think she has second thoughts about that.`);
    ImageClass.setImage(images.v6.Underpass_33);
    vanessa.talk(`Look at you!`);
    vanessa.talk(`You know. It's true that sometimes I give you a hard time. But it was so we could get to this point.`);
    vanessa.talk(`I'm so proud! I feel like my kid just graduated!`);
    ann.talk(`Hehe. I don't think it's the same but thanks.`);
    mc.think(`They casually started talking while rubbing our cocks... I can't say I've ever been in this situation before.`);


    return jump(V6Underpass_4, "V6Underpass_4");
};


export const V6Underpass_3_Question_Refuse = async (): Promise<any> => {
    ImageClass.setImage(images.v6.Underpass_31);
    mc.talk(`I'll rather not.`);
    ann.talk(`Really...?`);
    ImageClass.setImage(images.v6.Underpass_29);
    vanessa.talk(`Haha, no luck for you.`);
    vanessa.talk(`If you wanna touch Joe's dick if you wanna, I don't mind.`);
    ann.talk(`That's fine.`);

    return jump(V6Underpass_4, "V6Underpass_4");
};

export const V6Underpass_4 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.Underpass_42, { duration: 2 });
    empty.think(`*WHOOP WHOOP*`);
    mc.think(`What the fuck?`);

    ImageClass.setImage(images.v6.Underpass_43);
    officer.talk(`Well, well, well, what have we got here?`);

    ImageClass.setImage(images.v6.Underpass_44);
    officer.talk(`A junkies orgy.`);
    mc.think(`Where did he come from?`);
    ImageClass.setImage(images.v6.Underpass_38);
    vanessa.talk(`O-M-G! Which one of you ordered a stripper? That's genius!`);
    vanessa.talk(`Is that flashlight really necessary? You are blinding us without it already.`);


    ImageClass.setImage(images.v6.Underpass_44);
    officer.talk(`Unless you want to spend a night in the jailhouse, you better show me some respect young lady.`);
    officer.talk(`Now, can you explain your actions?`);
    vanessa.talk(`We...`);
    officer.talk(`Not you.`);
    officer.talk(`I've heard enough from you.`);

    return jump(Abandoned_4_Question, "Abandoned_4_Question");
};

export const Abandoned_4_Question = async (): Promise<any> => {

    ImageClass.setImage(images.v6.Underpass_45);
    await officer.setQuestion(new Question({ text: `The couple on the left. Speak, now.`, options: { think: false }, key: `v6UnderPassAnsweredTheOfficer` })
        .option({ title: `Answer him`, key: true })
        .option({ title: `Let Ann answer`, key: false }));


    if (Question.globalAnswers.v6UnderPassAnsweredTheOfficer) {

        return jump(Abandoned_4_Question_Answer, "Abandoned_4_Question_Answer");
    } else {

        return jump(Abandoned_4_Question_AnnAnswer, "Abandoned_4_Question_AnnAnswer");
    }
};


export const Abandoned_4_Question_Answer = async (): Promise<any> => {

    ImageClass.setImage(images.v6.Underpass_45);
    mc.talk(`Nothing officer... We are just a bunch of kids that wanted to have some fun, that's all... No harm was done.`);
    officer.talk(`You should be glad that I was the one passing through. The type of people that hang around here aren't the kind of people you'd like to meet...`);
    mc.talk(`Thank you sir we appreciate it.`);


    return jump(Abandoned_5, "Abandoned_5");
};


export const Abandoned_4_Question_AnnAnswer = async (): Promise<any> => {

    ImageClass.setImage(images.v6.Underpass_45);
    ann.talk(`Nothing!`);
    officer.talk(`It doesn't look like nothing.`);
    officer.talk(`I've never had the urge to go around and remove my clothes public.`);
    ann.talk(`Me neither... I...`);
    officer.talk(`I... I... I...`);
    officer.talk(`Do you know what they do to girls like you in prison?`);
    ann.talk(`Prison??`);
    officer.talk(`Exactly.`);
    ImageClass.setImage(images.v6.Underpass_38);
    vanessa.talk(`I'm sure he doesn't mean it. He just want us to get out of here.`);


    return jump(Abandoned_5, "Abandoned_5");
};

export const Abandoned_5 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.Underpass_40);
    officer.talk(`You kids are lucky that I don't have time for the paper work.`);
    officer.talk(`Get dressed right now and get out of here.`);
    officer.talk(`Next time I see you here again I won't be this nice.`);
    ImageClass.setImage(images.v6.Underpass_44);
    vanessa.talk(`Thank you officer!`);

    return jump(Abandoned_6, "Abandoned_6");
};

export const Abandoned_6 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.Underpass_41, { duration: 1, transition: true });
    vanessa.talk(`What a way to ruin the party, just when things started to get interesting.`);
    mc.talk(`Didn't you say you used to come here? You could've warned us.`);
    vanessa.talk(`I did, but it's the first time I've seen the police patrolling the area...`);
    vanessa.talk(`I guess things changed.`);
    joe.talk(`So where to now?`);
    vanessa.talk(`Just drop us at home.`);
    mc.talk(`Yeah. me too.`);
    ann.talk(`Same.`);
    joe.talk(`Sure.`);

    return jump(V6UnderPassAfter, "V6UnderPassAfter");
};
